import PropTypes from "prop-types";

// Layouts
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";

// MUI
import { Stack } from "@mui/material";

const getGrossDataDefinition = (grossType = "") => {
	if (grossType === "miniDeal") {
		return [
			{
				type: "Dollar",
				min: 0,
				max: 100000,
				decimalsEditable: false,
				decimals: 2,
			},
		];
	}

	return [
		{
			type: "Percent",
			min: 0,
			max: 100,
			decimalsEditable: true,
			decimals: 2,
		},
		{
			type: "Dollar",
			min: 0,
			max: 100000,
			decimalsEditable: false,
			decimals: 2,
		},
	];
};

const getMiniDealError = (gross = "", index = 0, errors = []) => {
	if (gross !== "miniDeal") {
		return false;
	}
	return Boolean(errors?.[index]?.[gross]);
};

export default function GrossProfitTier(props) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		grossIdentifiers = ["retail", "lease", "cash", "miniDeal"],
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 4,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		miniDealsErrors = [],
		readOnly = false,
		spacing = 0.8,
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [
								{
									type: "Dollar",
									min: -100000,
									max: 100000,
									decimalsEditable: true,
									decimals: 2,
									dashed: fromDisabled,
								},
							],
							sx: { width: "95px" },
							defaultType: "Dollar",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: true,
							readOnly: true,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, "from", value);
							},
						}}
						secondInput={{
							readOnly,
							data: [
								{
									type: "Dollar",
									min: -100000,
									max: 100000,
									decimalsEditable: true,
									decimals: 2,
									dashed: toDisabled,
								},
							],
							sx: { width: "95px" },
							defaultType: "Dollar",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, "to", value, 0.01);
							},
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{grossIdentifiers?.map((gross, key) => {
						const data = getGrossDataDefinition(gross);
						const defaultType = gross === "miniDeal" ? "Dollar" : item?.[gross]?.input || "Percent";
						const miniDealError = getMiniDealError(gross, index, miniDealsErrors);
						return (
							<Stack key={`input_profit_${gross}_${key}`} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={data}
									value={item?.[gross]?.value || 0}
									defaultType={defaultType}
									error={Boolean(columnsErrors?.[index]?.[gross]) || miniDealError}
									disabled={readOnly}
									readOnly={readOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, gross, input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, gross, value);
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
GrossProfitTier.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	grossIdentifiers: PropTypes.array,
	spaces: PropTypes.object,
	rowsErrors: PropTypes.array,
	columnsErrors: PropTypes.array,
	miniDealsErrors: PropTypes.array,
	readOnly: PropTypes.bool,
	spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	mainContentProps: PropTypes.object,
	sxMainContent: PropTypes.object,
	cellsProps: PropTypes.object,
	sxCells: PropTypes.object,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
